import axios from 'axios';
import axiosInstance from "./axiosInstance";

export interface MediaItem {
    id: string;
    type: string;
    url: string;
    name: string;
    recall: boolean;
    subCategory: string;
}

export interface ApiResponse {
    status: string;
    media: MediaItem[];
    meta: {
      current_page: number;
      per_page: number;
      total: number;
      last_page: number;
    };
    categories: { [key: string]: string[] };
    riskTypes: string[];
    locationTree: Record<string, any>;
}  

export interface MediaFilterParams {
    category?: string;
    subCategory?: string;
    riskDimension?: string;
    country?: string;
    state?: string;
    city?: string;
    page?: number;
    perPage?: number;
}

export interface GeminiParams {
    id: string;
    name: string;
    url: string;
    type: string;
    prompt: string;
}

export const fetchFilteredMedia = async (filters: MediaFilterParams = {}) => {
    try {
        const response = await axiosInstance.get<ApiResponse>("/media/filter", {
            params: filters,
        });
        return response.data;
    } catch (error:any) {
        console.error("Error fetching media", error);
        return error?.response?.data || null;
    }
};

export const uploadMedia = async (media: FormData) => {
    try {
        const response = await axiosInstance.post("/media/upload", media, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Accept: 'application/json',
            }
        });
        return response.data;
    } catch (error:any) {
        console.error("Error uploading media", error);
        return error?.response?.data || null;
    }
}

export const analyzeImageWithGemini = async (params: GeminiParams) => {
    try {
        const { id, ...resp } = params;
        const response = await axiosInstance.post(`/media/${id}/analyze-with-gemini`, resp);
        return response.data;
    } catch (error:any) {
        console.error("Error analyze gemini", error);
        return error?.response?.data || null;
    }
}